<template>
    <section class="app-main">
        <transition name="fade" mode="out-in">
            <router-view v-if="frashKey" @go-frash="goFrash" :key="key"></router-view>
        </transition>
    </section>
</template>

<script>
    export default {
      name: 'AppMain',
      data(){
          return{
              frashKey:true
          }
      },
      computed: {
        key() {
            return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
        }
      },

      methods:{
        goFrash:function(){
            this.frashKey = false;
            this.$nextTick(() => {
                 this.frashKey = true;
            })
        }
      }
    }
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// AppMain.vue?12e5a74e